import profileDefault from "@/assets/profile-65-fluffy.json";
import { deepCopy } from "@/utils";

const state = {
  fileName: "AM",
  data: deepCopy(profileDefault),
  default: deepCopy(profileDefault),
  lightIndex: 5,
};

const actions = {
  setFileName({ commit }, fileName) {
    commit("SET_FILE_NAME", fileName);
  },
  setData({ commit }, data) {
    data.key_layer.layer_data.map(({ layer }) => {
      layer.map((item, index) => {
        layer[index] = item.toUpperCase();
      });
    });
    commit("SET_DATA", data);
  },
  setLightIndex({ commit }, index) {
    commit("SET_LIGHT_INDEX", index);
    return;
  },
  SET_LIGHT_INDEX: (state, index) => {
    state.lightIndex = index;
  },
};

const mutations = {
  SET_FILE_NAME: (state, fileName) => {
    state.fileName = fileName;
  },
  SET_DATA: (state, data) => {
    state.data = data;
  },
  SET_LIGHT_INDEX: (state, index) => {
    state.lightIndex = index;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
